export function getPlaybackSeconds(player) {
  const value = typeof player?.getCurrentTime === 'function'
    ? player.getCurrentTime()
    : player?.currentTime;
  const seconds = Number(value);
  return Number.isFinite(seconds) && seconds > 0 ? Math.floor(seconds) : 0;
}

export function seekPlayback(player, seconds) {
  if (!player || !Number.isFinite(seconds)) return;
  if (typeof player.seek === 'function') player.seek(seconds);
  else if (typeof player.seekTo === 'function') player.seekTo(seconds, true);
  else if ('currentTime' in player) player.currentTime = seconds;
}
